<!--
 * @Author: 忠于自己 429022021@qq.com
 * @Date: 2025-01-18 12:28:02
 * @LastEditors: 忠于自己 429022021@qq.com
 * @LastEditTime: 2025-01-20 14:54:09
 * @FilePath: \duilvpcbase\src\views\originality\children\createTestReport\reportImg.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="report-img-box-p">
    <img :src="img.pic || img"
         alt=""
         v-for="(img,index) of reprotImgs"
         :key="index"
         style="width: 100%;">
  </div>

</template>

<script>
import pdf from 'vue-pdf'
import { GetProDetectionInfo, getJxjDetail } from '../../../../api/index.js';

export default {
  name: 'reportImg',
  components: {
    pdf
  },
  data () {
    return {
      reprotImgs: [],
      pdfSrc: ''
    }
  },
  methods: {
    async randomRgb () {
      var _this = this
      let res = await GetProDetectionInfo({
        id: this.$route.query.id
      })
      if (res.Type == 'Success') {
        var data = res.Data
        data.forEach(item => {
          if (item.Id == _this.$route.query.current_id) {
            console.log(item)
            if (item.PdfUrl !== null) {
              _this.pdfSrc = item.PdfUrl;
              window.location.href = 'https://www.iduilv.com/h5/report/web/viewer.html?file=' + item.PdfUrl

            } else {
              if (item.ImgUrl.charAt(0) == '[') {
                _this.reprotImgs = JSON.parse(item.ImgUrl)
              } else {
                _this.reprotImgs = item.ImgUrl.split(',')
              }
            }

          }
        })
      }
    },

    async init () {
      var _this = this
      let res = await getJxjDetail({
        id: this.$route.query.id
      })
      if (res.Type == 'Success') {
        var data = res.Data
        if (data.jointWarranty.charAt(0) == '[') {
          _this.reprotImgs = JSON.parse(data.jointWarranty)
        } else {
          _this.reprotImgs = data.jointWarranty.split(',')
        }
      }
    }
  },
  created () {
    if (!this.$route.query.current_id) {
      this.init()
    } else {
      this.randomRgb()
    }

  }
}
</script>

<style>
.report-img-box-p {
  width: 1170px;
  padding: 100px 0 50px 0;
  margin: auto;
}
</style>